<template>
  <!-- Risk Model Templates -->
  <router-link
    to="/system-admin/risk-model-templates"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">{{ MODULE_ICONS.kyx }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Modelos de KYX</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie os modelos globais de política de risco para as contas.</p>
      </div>
    </div>
  </router-link>

  <!--  Pulse Templates -->
  <router-link
    v-if="canAccessMonitoringConfig"
    to="/system-admin/monitoring-templates"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">{{ MODULE_ICONS.pulse }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Modelos de PULSE</h2>
        </div>
        <p class="text-gray-600 mt-1">Configure os modelos globais de monitoramento contínuo.</p>
      </div>
    </div>
  </router-link>

  <!-- KYT Templates -->
  <router-link
    to="/system-admin/kyt-templates"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">{{ MODULE_ICONS.kyt }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Modelos de KYT</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie os modelos globais de monitoramento de transações.</p>
      </div>
    </div>
  </router-link>

  <!-- CNAE Lists (System) -->
  <router-link
    to="/system-admin/cnae-lists"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">list</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Lista CNAE</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie listas globais de códigos CNAE de risco.</p>
      </div>
    </div>
  </router-link>

  <!-- Relationship Types (System / predefined catalog) -->
  <router-link
    to="/system-admin/relationship-types"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">category</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Tipos de Relacionamento</h2>
        </div>
        <p class="text-gray-600 mt-1">Ative ou desative os tipos de relacionamento pré-definidos globais.</p>
      </div>
    </div>
  </router-link>

  <!-- User Management (System) -->
  <router-link
    to="/system-admin/users"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">people</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Usuários</h2>
        </div>
        <p class="text-gray-600 mt-1">Visualize todos os usuários no sistema.</p>
      </div>
    </div>
  </router-link>

  <!-- Role Management (System) -->
  <router-link
    to="/system-admin/roles"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">verified_user</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Papéis</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie papéis globais e modelos de permissão.</p>
      </div>
    </div>
  </router-link>

  <!-- Workflow Templates (System) -->
  <router-link
    to="/system-admin/workflow-templates"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">account_tree</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Modelos de Workflow</h2>
        </div>
        <p class="text-gray-600 mt-1">Defina as etapas e campos padrão para novos fluxos.</p>
      </div>
    </div>
  </router-link>

  <!-- Account Management -->
  <router-link
    to="/system-admin/accounts"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">business</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Contas</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie contas e configure seus workflows de investigação.</p>
      </div>
    </div>
  </router-link>

  <router-link
    to="/system-admin/data-catalog"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <BaseIcon class="text-primary-600" :size="'lg'">inventory_2</BaseIcon>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Catálogo de Dados</h2>
        </div>
        <p class="text-gray-600 mt-1">Visualize os produtos de dados disponíveis e suas faixas de preço.</p>
      </div>
    </div>
  </router-link>

  <router-link
    to="/system-admin/regulatory-mappings"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <BaseIcon class="text-primary-600" :size="'lg'">gavel</BaseIcon>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Mapeamento Regulatório</h2>
        </div>
        <p class="text-gray-600 mt-1">Códigos por regulador e o vínculo de indicadores a códigos COAF.</p>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { MODULE_ICONS } from '@/constants/icons';
import { hasMonitoringConfigAccess } from '@/utils/auth';

const authStore = useAuthStore();
const canAccessMonitoringConfig = computed(() => hasMonitoringConfigAccess(authStore.user?.email));
</script>
